import state from './state'

// const rules = function() {
//     return {
//         counter: value => value.length == 3 || 'Debe ingresar 3 dígitos',
//     }
// }

// const getUniqueKey = function(){
//     return state.uniqueKey
// }

export default{
    // rules,
    // getUniqueKey,
}